import { props } from 'ts-action';

type MobileDrawerState = 'collapsed' | 'compact' | 'default';

export const PLATFORM_MOBILE_DRAWER_STATE_CHANGE = {
	category: '[Platform]',
	name: 'Mobile Drawer state change',
	payload: props<{ state: MobileDrawerState }>(),
} as const;

export const PLATFORM_MOBILE_DRAWER_STATE_INITIAL = {
	category: '[Platform]',
	name: 'Mobile Drawer state initial',
	payload: props<{ state: MobileDrawerState }>(),
} as const;

export const PLATFORM_MOBILE_DRAWER_POPULAR_VIDEO_SELECTED = {
	category: '[Platform]',
	name: 'Mobile Drawer popular video selected',
	payload: props<{
		playlist: string;
		playlistIndex: number;
		adPosition: string;
	}>(),
} as const;

export const PLATFORM_MOBILE_DRAWER_POPULAR_VIDEO_CLOSED = {
	category: '[Platform]',
	name: 'Mobile Drawer popular video closed',
} as const;
